/**
 * 공용 스크롤스파이 네비게이션 — 공통 UI 의 섹션 이동 메뉴(.spy-nav)를 채운다.
 *
 * PC: 좌측 세로 목록 / 태블릿 이하: 가로 한 줄 (모양은 common.css 가 정한다)
 * 링크 클릭 → 해당 섹션으로 부드럽게 이동, 스크롤 위치에 따라 현재 항목 강조.
 *
 * @param {HTMLElement} nav .spy-nav 요소 (안에 .spy-nav__list 가 있으면 거기에 넣는다)
 * @param {Array<{el: HTMLElement, label: string}>} sections 순서대로 표시할 섹션들
 * @return {Map<HTMLElement, HTMLAnchorElement>} 섹션 → 링크 (상태 표시 갱신용)
 */
const initScrollSpyNav = (nav, sections) => {
  if (!nav || !sections.length) {
    return new Map();
  }

  // 공통 spy-nav 규격: 링크는 목록(ul.spy-nav__list) 안에 들어간다
  const list = nav.querySelector('.spy-nav__list') || nav;

  list.textContent = '';

  const links = new Map();

  sections.forEach(({ el, label }, index) => {
    if (!el.id) {
      el.id = `qrshop-section-${index}`;
    }

    // 상단 고정 네비에 가리지 않도록 앵커 여백 확보
    el.classList.add('scroll-mt-24', 'lg:scroll-mt-6');

    const link = document.createElement('a');
    link.href = `#${el.id}`;
    link.className = 'spy-nav__link';

    // 섹션 입력 상태 표시용 점 — 상태는 호출부가 data-state 로 정한다
    const dot = document.createElement('span');
    dot.className = 'spy-nav__dot';
    dot.dataset.navDot = '';
    dot.setAttribute('aria-hidden', 'true');
    link.append(dot, document.createTextNode(label));

    link.addEventListener('click', (event) => {
      event.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const item = document.createElement('li');
    item.append(link);

    links.set(el, link);
    list.append(item);
  });

  // 현재 항목 표시만 바꾼다. 가로로 누운 화면에서 그 항목을 보이게 미는 일은
  // initSpyNav 가 class 변화를 지켜보다 처리한다.
  const setActive = (target) => {
    links.forEach((link, sectionEl) => {
      link.classList.toggle('spy-nav__link--current', sectionEl === target);
    });
  };

  // 화면 상단 1/4 지점을 지나는 섹션을 현재 섹션으로 본다
  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      if (visible.length) {
        setActive(visible[0].target);
      }
    },
    { rootMargin: '-15% 0px -65% 0px', threshold: 0 }
  );

  sections.forEach(({ el }) => observer.observe(el));
  setActive(sections[0].el);

  return links;
};

export default initScrollSpyNav;
